"use client";
import { useEffect } from "react";
import NewSelectInput from "../../../components/NewSelectInput";
import NewinputField from "../../../components/NewInput";
import { useLineHaulAllCompanyListData } from "../../../apis/pickupApis";
import {
  useFetchDriversAllData,
  useFetchDriversAllDataForPickupMerchant,
} from "../../../apis/driverApis";
import { UseFormClearErrors } from "react-hook-form";

const assignTypes = [
  { value: "LINEHAUL", text: "Linehaul" },
  { value: "DRIVER", text: "Inhouse" },
];

type AssignModalProps = {
  register?: any;
  errors?: any;
  setValue: (name: string, value: any) => void;
  watch: (name: string) => any;
  clearErrors?: UseFormClearErrors<any>;
  pickup?: any;
};

const AssignLineHoulVehicleModal: React.FC<AssignModalProps> = ({
  register,
  errors,
  setValue,
  watch,
  clearErrors,
  pickup,
}) => {
  useEffect(() => {
    setValue("assignType", "LINEHAUL");
  }, []);

  const { data } = useLineHaulAllCompanyListData();

  const linehaulCompanyId = watch("linehaulCompanyId");

  const { data: driverData } = useFetchDriversAllDataForPickupMerchant(
    "",
    pickup?.fromWarehouseId ?? "",
  );

  const driverListData = Array.isArray(driverData)
    ? driverData
    : (driverData?.data ?? []);

  return (
    <div className="relative group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 border border-[#D2D2D2]/70 p-2.5 transition-all duration-300 space-y-1.5">
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

      <div className="grid grid-cols-2 gap-4">
        <NewSelectInput
          label="Type"
          name="assignType"
          register={register}
          clearErrors={clearErrors}
          validation={{ required: "Assign Type is required" }}
          error={errors.assignType}
          value={watch("assignType")}
          onChange={(val) => {
            setValue("assignType", val);
          }}
          selectOptions={assignTypes}
          className="flex items-center gap-2"
        />
        {watch("assignType") === "LINEHAUL" && (
          <NewSelectInput
            name="linehaulCompanyId"
            className="flex items-center gap-2"
            label="Driver"
            selectOptions={
              data?.map((w: any) => ({
                id: w.id,
                value: w.id,
                text: w.assignedCompany,
              })) || []
            }
            register={register}
            clearErrors={clearErrors}
            validation={{ required: "Linehaul Company is required" }}
            error={errors.linehaulCompanyId}
            disabled={!data || data.length === 0}
            value={linehaulCompanyId}
            setValue={(val: string) => {
              setValue("linehaulCompanyId", val);
              setValue(
                "driverContact",
                data?.find((driver: any) => driver?.id === val)?.driverMobile,
              );
              setValue(
                "driverNameLine",
                data?.find((driver: any) => driver?.id === val)?.driverName,
              );
            }}
          />
        )}

        {/* <p className="text-[#212121]/80 w-full uppercase text-sm font-medium col-span-2">
            Driver Details
          </p> */}
        {watch("assignType") === "DRIVER" && (
          <>
            <NewSelectInput
              label="Driver"
              className="flex items-center gap-2"
              name="driverId"
              placeholder="Select Driver"
              register={register}
              selectOptions={driverListData?.map((driver: any) => ({
                id: driver?.id,
                value: driver?.id,
                text: driver?.name,
              }))}
              clearErrors={clearErrors}
              validation={{ required: "Driver is required" }}
              error={errors.driverId}
              disabled={!driverListData.length}
              value={watch("driverId")}
              setValue={(value: any) => {
                setValue("driverId", value);
                setValue(
                  "driverContact",

                  driverData?.find((driver: any) => driver?.id === value)
                    ?.mobileNo,
                );
                setValue(
                  "driverIqamaNumber",

                  driverData?.find((driver: any) => driver?.id === value)
                    ?.iqamaNumber,
                );
              }}
            />
            {/* <NewinputField
                type="number"
                 className="flex items-center gap-2"
                name="driverContact"
                title="Contact"
                placeholder="Enter Driver Contact"
                disabled
                value={watch("driverContact")}
                register={register}
                error={errors.driverContact}
              />
              <NewinputField
               className="flex items-center gap-2"
                type="number"
                name="driverIqamaNumber"
                title="Iqama Number"
                placeholder="Enter Iqama Number"
                disabled
                value={watch("driverIqamaNumber")}
                register={register}
                error={errors.driverIqamaNumber}
              /> */}
          </>
        )}

        {/* Driver */}
        {/* {watch("assignType") === "LINEHAUL" && (
            <>
              <NewinputField
                type="text"
                name="driverNameLine"
                title="Driver"
                placeholder="Enter Driver Contact"
                disabled
                value={watch("driverNameLine")}
                register={register}
                error={errors.driverNameLine}
              />
              <NewinputField
                type="number"
                name="driverContact"
                title="Contact"
                placeholder="Enter Driver Contact"
                disabled
                value={watch("driverContact")}
                register={register}
                error={errors.driverContact}
              />
            </>
          )} */}
      </div>
    </div>
  );
};

export default AssignLineHoulVehicleModal;
